module.exports = __webpack_public_path__ + "static/media/iconClose2.25cc3561.svg";